import { styled } from '@mui/material/styles';
import React from 'react';
import { Toolbar } from '@mui/material';
import AppBar from '@mui/material/AppBar';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  borderTop: `0.5px solid ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.common.white,
  color: theme.palette.common.black,
})) as typeof AppBar;

interface IProps {
  children: React.ReactNode;
  className?: string;
  toolbarClassName?: string;
  elevation?: number;
}

export const BottomBar = ({ elevation, children, className, toolbarClassName }: IProps) => {
  return (
    <StyledAppBar component={'nav'} position={'static'} className={className} elevation={elevation ?? 0}>
      <Toolbar className={toolbarClassName}>{children}</Toolbar>
    </StyledAppBar>
  );
};
